// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'conveyor-cargo';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M16.969 14.546a1.773 1.773 0 0 1-1.771 1.771H2.802a1.77 1.77 0 0 1 0-3.542h12.396a1.77 1.77 0 0 1 1.77 1.771zm-13.459 0h.355m3.187 0h.354m3.188 0h.354m3.187 0h.355M3.865 8.411h4.25a.708.708 0 0 1 .708.709v3.655H3.156V9.12a.708.708 0 0 1 .709-.709zM16.794 5.16H5.284m7.501-3.477 4.01 3.478-4.01 3.478M5.99 8.411v1.913'
  />
);

export const viewBox = '0 0 18 18';
